import React from "react";
import * as Yup from "yup";
import { isMobile } from "react-device-detect";
import { Divider, IconButton } from "@material-ui/core";
import { Facebook, LinkedIn, Close } from "@material-ui/icons";
import { Formik, Field } from "formik";
import { WelcomeMessage } from "../WelcomeMessage/WelcomeMessage";
import { FormikCheckboxField } from "../../../shared/Formik/FormikCheckboxField";
import {
  DialogContainer,
  FlexWrapper,
  LoginWrapper,
  SocialLoginWrapper,
  SocialLogin,
  RulesMessage,
  StyledButton,
  Footer,
  DontHaveAccount,
  DividerWrapper,
  StyledLink,
  ErrorMessage,
  LoginOptionsWrapper,
  ForgotPassword,
  StyledLabel,
  StyledDialogHeader,
} from "./SignIn.styles";
import { DialogTitle } from "../Dialog.styles";
import { modalState } from "../../../redux/actions/modalAction";
import { login } from "../../../redux/actions/authAction";
import { connect, useDispatch } from "react-redux";
import { Input, message } from "antd";
import { blogsLoginAPI, coreLoginAPI } from "../../../api/Auth";
import { getBlogsAPI } from "../../../api/GetBlogs";
import { useAuthStore } from "../../../store/AuthStore";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Email isn't Valid").required("Email is Required"),
  password: Yup.string().required("Password is Required"),
});

const SignIn = (props) => {
  const { setSignUpState } = props;
  const { setAuthData } = useAuthStore();
  const dispatch = useDispatch();

  const currentLocation = window.location.href;
  const initialValues = {
    email: "",
    password: "",
    rememberMe: true,
  };

  const redirectOutsite = (path) => {
    //eslint-disable-next-line
    location.href = path;
  };

  const socialIcons = [
    {
      icon: <Facebook />,
      label: "Facebook",
      hexColor: "#3b5998",
      url: `/oauth/login/facebook/?next=${currentLocation}`,
    },
    {
      icon: "G",
      label: "Google",
      hexColor: "#DE483C",
      url: `/oauth/login/google-oauth2/?next=${currentLocation}`,
    },
    {
      icon: <LinkedIn />,
      label: "LinkedIn",
      hexColor: "#0e76a8",
      url: `/oauth/login/linkedin-oauth2/?next=${currentLocation}`,
    },
  ];

  const coreLogin = async (values) => coreLoginAPI(values).then(mainLogin);

  const mainLogin = async (coreKey) => {
    if (coreKey === "Unable to log in with provided credentials.") {
      message.error("Invalid Credentials");
      return;
    }

    blogsLoginAPI(coreKey).then((data) => {
      const res = data.data;
      const msg = data.message;

      localStorage.setItem("BlogsConsumerToken", res.token);
      localStorage.setItem("BlogsConsumerUser", JSON.stringify(res));
      message.success(msg);

      if (res.role === "physician") {
        getDefaultBlog(res);
      } else {
        setAuthData({
          hasBlog: false,
          isLoggedIn: true,
          mainBlogId: null,
          blogData: null,
          isPhysician: false,
          userData: res,
        });
      }
    });
  };

  const getDefaultBlog = async (user) =>
    getBlogsAPI(1, 1, "published", "", "", "", "", user.id).then(
      ({ blogs }) => {
        // No Blog Found
        if (blogs.length === 0) {
          const payload = {
            hasBlog: false,
            isLoggedIn: true,
            mainBlogId: null,
            blogData: null,
            isPhysician: true,
            userData: user,
          };

          setAuthData(payload);
          dispatch({
            type: "SET_USER_DATA",
            payload: payload,
          });

          return;
        }

        // Blog Found
        const currBlog = blogs[0];
        const payload = {
          hasBlog: true,
          isLoggedIn: true,
          mainBlogId: currBlog.id,
          blogData: currBlog,
          isPhysician: true,
          userData: user,
        };

        setAuthData(payload);
        dispatch({
          type: "SET_USER_DATA",
          payload: payload,
        });
      }
    );

  return (
    <DialogContainer
      fullScreen={isMobile}
      open={props.isOpen}
      onClose={() => props.modalState(false)}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={(values) => {
          props.modalState(false);
          // props.login(values, history);
          coreLogin(values);
        }}
      >
        {({
          submitForm,
          values,
          handleChange,
          errors,
          touched,
          handleBlur,
        }) => (
          <FlexWrapper>
            {!isMobile && <WelcomeMessage setSignUpState={setSignUpState} />}
            <LoginWrapper>
              {isMobile ? (
                <StyledDialogHeader>
                  <DialogTitle>Login With</DialogTitle>
                  <IconButton onClick={() => props.modalState(false)}>
                    <Close />
                  </IconButton>
                </StyledDialogHeader>
              ) : (
                <h3>Login With</h3>
              )}
              <SocialLoginWrapper>
                {socialIcons.map((each) => (
                  <SocialLogin
                    onClick={() => redirectOutsite(each.url)}
                    iconHex={each.hexColor}
                  >
                    {each.icon}
                  </SocialLogin>
                ))}
              </SocialLoginWrapper>
              <DividerWrapper>
                <span>OR</span>
                <Divider />
              </DividerWrapper>
              <StyledLabel>Email</StyledLabel>
              <Input
                name="email"
                type="email"
                placeholder="Email ID"
                onChange={handleChange}
                className="login-input"
                value={values.email}
                onBlur={handleBlur}
              />
              <ErrorMessage>
                {errors.email && touched.email && errors.email}
              </ErrorMessage>
              <StyledLabel>Password</StyledLabel>
              <Input.Password
                name="password"
                type="password"
                placeholder="Password"
                onChange={handleChange}
                className="login-input"
                value={values.password}
                onBlur={handleBlur}
              />
              <ErrorMessage>
                {errors.password && touched.password && errors.password}
              </ErrorMessage>
              <LoginOptionsWrapper>
                <ForgotPassword
                  onClick={() => redirectOutsite("/accounts/password/reset/")}
                >
                  Forgot your password?
                </ForgotPassword>
                <Field
                  name="rememberMe"
                  label="Keep me logged in"
                  component={FormikCheckboxField}
                />
              </LoginOptionsWrapper>
              <Footer>
                <RulesMessage>
                  By logging into DoveMed you agree to our {isMobile && <br />}
                  <StyledLink
                    onClick={() =>
                      redirectOutsite("/about-us/terms-conditions/")
                    }
                  >
                    {" "}
                    Terms of Use{" "}
                  </StyledLink>
                  and
                  <StyledLink
                    onClick={() => redirectOutsite("/privacy-policy/")}
                  >
                    {" "}
                    Privacy Policy
                  </StyledLink>
                </RulesMessage>
                <div>
                  <StyledButton
                    color="primary"
                    variant="contained"
                    onClick={submitForm}
                  >
                    Login
                  </StyledButton>
                  {isMobile && (
                    <DontHaveAccount>
                      Don't have an account yet?{" "}
                      <span onClick={() => setSignUpState(true)}>SIGNUP</span>
                    </DontHaveAccount>
                  )}
                </div>
              </Footer>
            </LoginWrapper>
          </FlexWrapper>
        )}
      </Formik>
    </DialogContainer>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modalReducer.isOpen,
});
export default connect(mapStateToProps, { modalState, login })(SignIn);
